import { ariesBrowserFallbacks } from './aries'
import { audioNoteBrowserFallbacks } from './audio-note'
import { authBrowserFallbacks } from './auth'
import { baseBrowserFallbacks } from './base'
import { billingBrowserFallbacks } from './billing'
import { contextBrowserFallbacks } from './context'
import { overlayBrowserFallbacks } from './overlay'
import { systemBrowserFallbacks } from './system'
import { BROWSER_NOOP_ACTIONS, BROWSER_PERMISSION_ACTIONS } from './policies'
import type { BrowserFallbackRegistry } from './types'

export const browserFallbackRegistry: BrowserFallbackRegistry = {
  ...authBrowserFallbacks,
  ...ariesBrowserFallbacks,
  ...baseBrowserFallbacks,
  ...audioNoteBrowserFallbacks,
  ...contextBrowserFallbacks,
  ...overlayBrowserFallbacks,
  ...systemBrowserFallbacks,
  ...billingBrowserFallbacks,
}

export { BROWSER_NOOP_ACTIONS, BROWSER_PERMISSION_ACTIONS }
